(() => {
	function init() {
		const filter = document.querySelector('[data-filter-category]');
		const content = document.querySelector('#content');
		const spinnerProducts = document.querySelector('#spinner-products');
		const spinnerFilter = document.querySelector('#spinner-filter');

		const parser = new DOMParser();
		let isLoading = false;

		if (!filter || !content) {
			return;
		}

		// Filter
		// ----------------------------------------

		filter.addEventListener('change', async () => {
			await hideContent();
			spinnerFilter.classList.remove('d-none');

			const url = getUrl();
			const data = await ajax('GET', url);
			const newDoc = parser.parseFromString(data, 'text/html');
			const newContent = newDoc.querySelector('#content');

			content.dataset.currentPage = newContent.dataset.currentPage;
			content.dataset.totalPages = newContent.dataset.totalPages;
			content.innerHTML = newContent.innerHTML;

			initPageLinks();

			spinnerFilter.classList.add('d-none');
			await showContent();
		});

		// Load more products
		// ----------------------------------------

		initBtn();

		async function loadProducts(btn) {
			let url = btn.getAttribute('href');
			const data = await ajax('GET', btn.getAttribute('href'));
			const newDoc = parser.parseFromString(data, 'text/html');
			const title = newDoc.querySelector('title').innerText;
			const newContent = newDoc.querySelector('#content');
			const newProducts = newDoc.querySelectorAll('#products > a');
			const newBtn = newDoc.querySelector('#load-products');

			content.dataset.currentPage = newContent.dataset.currentPage;
			content.dataset.totalPages = newContent.dataset.totalPages;

			// Add new products
			newProducts.forEach((product) => {
				product.classList.add('new-product');

				gsap.set(product, {
					opacity: 0,
					y: 50
				});

				products.appendChild(product);
			});

			document.querySelector('#load-products').remove();

			if (!!newBtn) {
				document.querySelector('#content > div').insertBefore(newBtn, null);
				initBtn();
			}

			// Update links
			initPageLinks();

			// Animate
			const productEls = document.querySelectorAll('a.new-product');

			await gsap.timeline().to(productEls, {
				duration: 0.3,
				stagger: 0.1,
				opacity: 1,
				y: 0
			});

			productEls.forEach((el) => el.classList.remove('new-product'));

			// Change the page URL
			if (typeof window.history.pushState === 'function') {
				window.history.pushState('', '', url);
			}

			// Trigger gtag
			if (gtag && typeof gtag === 'function') {
				gtag('config', GTAG_ID, {
					page_title: title,
					page_path: url.split('.co.nz').pop()
				});
			}
		}

		function initBtn() {
			const btn = document.querySelector('#load-products > a');

			if (!btn) return false;

			document.querySelector('#load-products > a').addEventListener('click', async (e) => {
				e.preventDefault();

				e.target.classList.add('-loading');
				loadProducts(e.target);
			});
		}

		// Func
		// ----------------------------------------

		async function hideContent() {
			await gsap.to(content, {
				duration: 0.33,
				opacity: 0,
				x: -50
			});
		}

		async function showContent() {
			await gsap.to(content, {
				duration: 0.33,
				opacity: 1,
				x: 0
			});
		}

		function getUrl() {
			let val = filter.value;
			let url = `${ROOT}shop/category/${filter.dataset.filterCategory}/`;

			if (val !== '*') {
				url += val;
			}

			return url;
		}
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		if ($BODY.hasClass('category-page')) {
			init();
		}
	});

	$WINDOW.on('page:load-completed', (e) => {
		if ($BODY.hasClass('category-page')) {
			init();
		}
	});
})();
